import { createAction } from 'redux-actions';
import { fetchJson } from '../../../../../../utils/fetch';

export const fetchFormAction = createAction('step3.FETCH_FORM');
export const fetchFormSuccessAction = createAction('step3.FETCH_FORM_SUCCESS');
export const updateDataAction = createAction('step3.UPDATE_FIELD');

export const fetchForm = caseId => (dispatch, getState) => {
  const state = getState();
  if (state.form.isFetching) {
    return Promise.resolve();
  }

  dispatch(fetchFormAction());

  if (caseId) {
    return fetchJson(`/pco-manager/cases-creation/${caseId}/step3.json`).then(
      response => {
        dispatch(fetchFormSuccessAction(response));
      }
    );
  } else {
    return dispatch(fetchFormSuccessAction({}));
  }
};

export const updateData = (siteId, propName, propValue) => (
  dispatch,
  getState
) => {
  dispatch(updateDataAction({ siteId, propName, propValue }));
};



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step3/actions/form.js